/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useCallback } from "react";
import ComplicationSelector from "@ls/grouping-complication-selector";
import { useDispatch, useSelector } from "react-redux";
import AttributeDefinition from "state/attributes/AttributeDefinition";
import { setDefinition as setAttributeDefinition } from "state/attributes/actions";
import { selectDefinitions } from "state/attributes/selectors";
import SelectionState from "state/selections/SelectionState";
import AttributesSelectorComplication from "./AttributesSelectorComplication";

const AttributesSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (idx, definition) => {
      dispatch(setAttributeDefinition(idx, definition));
    },
    [dispatch]
  );

  return (
    <div>
      <ComplicationSelector
        selectedDefinitions={definitions}
        setDefinition={setDefinition}
        getDefaultDefinition={AttributeDefinition.getDefault}
        ComplicationComponent={AttributesSelectorComplication}
        btnTitle={"Attributes"}
        addMoreText={"Attribute Column"}
      />
    </div>
  );
};

export default memo(AttributesSelector);
